import { listGroups } from '@modusign/openapi-client-user';
import {
  ListGroupsParams,
  ListGroupsResponseDto,
} from '@modusign/openapi-client-user/generated/model';
import { AxiosError } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query';

export default function useInfiniteListGroups<TData = ListGroupsResponseDto, TError = AxiosError>(
  workspaceId: string,
  params?: Omit<ListGroupsParams, 'offset'>,
  options?: Omit<
    UseInfiniteQueryOptions<ListGroupsResponseDto, TError, TData>,
    'queryKey' | 'queryFn' | 'getNextPageParam'
  >
) {
  return useInfiniteQuery<ListGroupsResponseDto, TError, TData>({
    queryKey: ['infiniteListGroups', workspaceId, params],
    queryFn: ({ pageParam = 0 }) =>
      listGroups(workspaceId, {
        offset: pageParam,
        ...params,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const currentDataCount: number = allPages.reduce((acc, page) => acc + page.groups.length, 0);
      return currentDataCount < lastPage.count && currentDataCount;
    },
    ...options,
  });
}
